import { Card } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import styles from '../styles/Activity.module.scss';
import RiskRadiobuttonGroup from './RiskRadiobuttonGroup';
import GridColumnInputWrapper from '@components/common/GridColumnInputWrapper';
import ExternalDocumentTagsUrlInputWrapper from '@components/common/ExternalDocumentTagsUrlInputWrapper';
import { useFormContext } from 'react-hook-form';
import { useEffect } from 'react';
import { edmsReferenceValidation } from '@components/Activity/types/Validations';
import lodash from 'lodash';

type Props = {
  header: string;
  value: string;
  setValue?: (value: string) => void;
  naValue?: boolean;
  edmsNo?: boolean;
  text?: string;
  setText?: (text: string) => void;
  placeholder?: string;
  name: string;
  disabled?: boolean;
};

const RiskRadiobuttonContainer = ({
  header,
  value,
  setValue,
  naValue,
  edmsNo,
  text,
  setText,
  placeholder,
  name,
  disabled,
}: Props) => {
  const { t } = useTranslation();
  const key = name + '.edms';
  const {
    register,
    formState: { errors },
    setValue: setFormValue,
    trigger,
  } = useFormContext();

  useEffect(() => {
    setFormValue(key, text);
    trigger([key]);
  }, [text]);

  const registerKey = register(key, edmsReferenceValidation(t));

  return (
    <div className={styles.activityTextContainer}>
      <Card className={styles.cardText}>
        <div className={styles.basicDivRadioButton}>
          <div className={styles.riskTextHeader}>{t(header)}</div>
          <RiskRadiobuttonGroup
            value={value}
            setValue={setValue}
            naValue={naValue}
            name={name}
            disabled={disabled}
          />
          {edmsNo && (
            <div className={styles.checkboxContainerText}>
              <div className={styles.errorMessage}>
                {lodash.get(errors, key)?.message?.toString()}
              </div>

              <GridColumnInputWrapper
                value={text}
                disabled={disabled}
                rows={1}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  if (setText) {
                    setText(e.target.value);
                  }
                }}
                render={(props: Record<string, unknown>) => (
                  <ExternalDocumentTagsUrlInputWrapper
                    {...registerKey}
                    {...props}
                    onlyUnique={true}
                    onlyAutocomplete={false}
                    value={text}
                    setFieldValue={(field: string, value: string) => {
                      setText?.(value);
                    }}
                    placeholder={placeholder}
                    maxTags={1}
                  />
                )}
              />
            </div>
          )}
        </div>
      </Card>
    </div>
  );
};

export default RiskRadiobuttonContainer;
